import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import VerifyOtpAndEnrollApi from '@custom/rtk-apis/abha/verifyOtpAndEnroll';

const initialState = {
  data: {},
  status: "",
  loading: false,
  error: "",
  message: "",
};

const VerifyOtpAndEnrollSlice = createSlice({
    name: 'Verify Abha OTP',
    initialState,
    reducers: {
      clearState: state => {
        state.data = {};
        state.status = '';
        state.loading = false;
        state.error = '';
        state.message = '';
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(VerifyOtpAndEnrollApi.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(VerifyOtpAndEnrollApi.fulfilled, (state, action: PayloadAction<any>) => {
          state.loading = false;
          state.status = action.payload.status;
          state.data = action.payload.data;
          state.message = action.payload.data.message;
        })
        .addCase(VerifyOtpAndEnrollApi.rejected, (state, action: PayloadAction<any>) => {
          console.log("state.error", action.payload)
          state.loading = false;
          state.status = "FAILED";
          state.error = action.payload;
        });
    },
  });
  
export default VerifyOtpAndEnrollSlice.reducer;
export const { clearState } = VerifyOtpAndEnrollSlice.actions;
